import React, {
  memo,
  useCallback,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Tooltip,
} from 'reactstrap';

import './style.scss';

const AppTooltip = (props) => {
  const {
    autoHide,
    isShow,
    className,
    innerClassName,
    content,
    children,
    placement,
    delay,
  } = props;

  const [isShowTooltip, setIsShowTooltip] = useState(false);

  const onToggleTooltip = useCallback(() => () => {
    setIsShowTooltip((preState) => !preState);
  }, []);

  const generateTarget = useMemo(() => `TooltipTarget-${Math.random()
    .toString(36)
    .slice(2)}`, []);

  return (
    <>
      <Tooltip
        placement={placement}
        isOpen={isShowTooltip && isShow}
        target={generateTarget}
        toggle={onToggleTooltip()}
        className={`tooltip-white ${className || ''}`.trim()}
        innerClassName={innerClassName}
        autohide={autoHide}
        delay={delay}
      >
        {content}
      </Tooltip>

      <div
        type="button"
        className="btn btn-tooltip d-flex align-items-center"
        id={generateTarget}
      >
        {children}
      </div>
    </>
  );
};

AppTooltip.propTypes = {
  autoHide: PropTypes.bool,
  isShow: PropTypes.bool,
  className: PropTypes.string,
  innerClassName: PropTypes.string,

  content: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Object),
  ]),
  placement: PropTypes.oneOf([
    'auto',
    'auto-start',
    'auto-end',
    'top',
    'top-start',
    'top-end',
    'right',
    'right-start',
    'right-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'left-start',
    'left-end',
  ]),
  delay: PropTypes.oneOfType([
    PropTypes.shape({ show: PropTypes.number, hide: PropTypes.number }),
    PropTypes.number,
  ]),
};

AppTooltip.defaultProps = {
  autoHide: false,
  isShow: true,
  className: '',
  innerClassName: '',

  children: <i className="bx bx-help-circle ms-1" />,
  placement: 'top',
  delay: {
    show: 100,
    hide: 200,
  },
};

export default memo(AppTooltip);
